import Rails from "@rails/ujs";

let updateNUModalContent = function(
  dataset, message, dialogMessage, dialogTitle, cancelButton, okButton,
  deleteButton, errorIcon, warningIcon, successIcon, confirmationCheckContainer,
) {

  if (message) {
    dialogMessage.innerHTML = message;
  }

  if (dataset) {
    if (dataset.confirmMessage) {
      dialogMessage.innerHTML = dataset.confirmMessage;
    }

    if (dataset.confirmTitle) {
      dialogTitle.innerHTML = dataset.confirmTitle;
    }

    if (dataset.confirmCancel) {
      cancelButton.innerHTML = dataset.confirmCancel;
    }

    if (dataset.confirmAllow) {
      okButton.innerHTML = dataset.confirmAllow;

      if (deleteButton) {
        deleteButton.innerHTML = dataset.confirmAllow;
      }
    }

    // Admin confirmation modal specific code
    if (dataset.confirmError) {
      okButton.classList.add('hidden');
      deleteButton.classList.remove('hidden');
      warningIcon.classList.add('hidden');
      errorIcon.classList.remove('hidden');
    }

    // Admin confirmation modal specific code
    if (dataset.confirmSuccess) {
      warningIcon.classList.add('hidden');
      successIcon.classList.remove('hidden');
    }

    if (dataset.confirmCheck === 'true') {
      deleteButton.disabled = true;

      confirmationCheckContainer.querySelector('#checkbox-label')
        .textContent = dataset.confirmCheckMessage;
      confirmationCheckContainer.classList.remove('hidden');
    }
  }
}

// Hiding the page's overflow takes the scrollbar with it, and the page widens
// into the space it left, which reads as the screen jumping when the modal
// opens. Browsers that draw the scrollbar over the content have nothing to
// give back, so they measure zero and are left alone.
const lockBackgroundScroll = function(backgroundBody) {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  backgroundBody.classList.add('overflow-hidden');

  if (scrollbarWidth > 0) {
    backgroundBody.style.paddingRight = `${scrollbarWidth}px`;
  }
}

const unlockBackgroundScroll = function(backgroundBody) {
  backgroundBody.classList.remove('overflow-hidden');
  backgroundBody.style.paddingRight = '';
}

Rails.confirm = function(
  message, element, dataset = null, options = {}
) {
  let backgroundBody = document.querySelector('#js-body');
  let dialog = document.querySelector('#confirmation-modal');
  let dialogMessage = dialog.querySelector('#modal-content');
  let dialogTitle = dialog.querySelector('#modal-title');
  let okButton = dialog.querySelector('.modal-ok-button');
  let cancelButton = dialog.querySelector('.modal-cancel-button');

  let defaultMessage = dialogMessage.innerHTML;
  let defaultTitle = dialogTitle.innerHTML;
  let defaultOkText = okButton.innerHTML;
  let defaultCancelText = cancelButton.innerHTML;

  // Admin confirmation modal specific variables
  let errorIcon = dialog.querySelector('#modal-icon-error');
  let warningIcon = dialog.querySelector('#modal-icon-warning');
  let successIcon = dialog.querySelector('#modal-icon-success');
  let deleteButton = dialog.querySelector('.modal-delete-button');
  let defaultDeleteText;

  let confirmationCheckContainer = dialog.querySelector('#modal-confirmation');
  let confirmationCheck = null;
  let confirmationCheckText = null;

  if (confirmationCheckContainer) {
    confirmationCheck = confirmationCheckContainer
      .querySelector('input[type="checkbox"]');

    confirmationCheckText = confirmationCheckContainer
      .querySelector('.modal-confirmation-text');
  }

  let confirmCallback = options.confirmCallback || null;
  let cancelCallback = options.cancelCallback || null;

  if (deleteButton) {
    defaultDeleteText = deleteButton.innerHTML;
  }

  const data = (dataset || element.dataset);

  updateNUModalContent(data, message, dialogMessage, dialogTitle, cancelButton, okButton,
    deleteButton, errorIcon, warningIcon, successIcon, confirmationCheckContainer, confirmationCheckText);

  dialog.classList.remove('hidden');
  lockBackgroundScroll(backgroundBody);

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      if (document.activeElement === cancelButton && event.shiftKey) {
        okButton.focus();
        event.preventDefault();
      } else if ((document.activeElement === okButton || document.activeElement === deleteButton) && !event.shiftKey) {
        cancelButton.focus();
        event.preventDefault();
      }
    }
  });

  const checkAction = () => {
    deleteButton.disabled = !confirmationCheck.checked;
  }

  const confirmAction = () => {
    dialog.classList.add('hidden');
    unlockBackgroundScroll(backgroundBody);

    dialogMessage.innerHTML = defaultMessage;
    dialogTitle.innerHTML = defaultTitle;
    okButton.innerHTML = defaultOkText;
    cancelButton.innerHTML = defaultCancelText;

    if (deleteButton) {
      deleteButton.innerHTML = defaultDeleteText;
    }

    errorIcon?.classList.add('hidden');
    successIcon?.classList.add('hidden');
    deleteButton?.classList.add('hidden');

    if (confirmationCheck) {
      confirmationCheck.checked = false;
      confirmationCheckContainer.classList.add('hidden');
      confirmationCheck.removeEventListener('change', checkAction);
    }

    if (!confirmCallback) {
      let old = Rails.confirm
      Rails.confirm = function() { return true }
      element.click();
      Rails.confirm = old
    }

    okButton.removeEventListener('click', confirmAction);
    cancelButton.removeEventListener('click', cancelAction);

    if (deleteButton) {
      deleteButton.removeEventListener('click', confirmAction);
      deleteButton.disabled = false;
      okButton.classList.remove('hidden');
      warningIcon.classList.remove('hidden');
      errorIcon.classList.add('hidden');
    }

    if (confirmCallback) {
      confirmCallback();
    }

    document.dispatchEvent(new CustomEvent('promote:shortcuts--unregister', {
      detail: { group: 'confirm-dialog' }
    }));
  };

  const cancelAction = () => {
    dialog.classList.add('hidden');
    unlockBackgroundScroll(backgroundBody);

    dialogMessage.innerHTML = defaultMessage;
    dialogTitle.innerHTML = defaultTitle;
    okButton.innerHTML = defaultOkText;
    cancelButton.innerHTML = defaultCancelText;

    errorIcon?.classList.add('hidden');
    successIcon?.classList.add('hidden');
    deleteButton?.classList.add('hidden');

    okButton.removeEventListener('click', confirmAction);

    if (confirmationCheck) {
      confirmationCheckContainer.classList.add('hidden');

      confirmationCheck.checked = false;
      confirmationCheck.removeEventListener('change', checkAction);
    }

    if (deleteButton) {
      deleteButton.disabled = false;
      deleteButton.innerHTML = defaultDeleteText;
      deleteButton.removeEventListener('click', confirmAction);

      okButton.classList.remove('hidden');
      warningIcon.classList.remove('hidden');
      errorIcon.classList.add('hidden');
    }

    document.dispatchEvent(new CustomEvent('promote:shortcuts--unregister', {
      detail: { group: 'confirm-dialog' }
    }));

    document.dispatchEvent(new CustomEvent('promote:confirm-cancel', {
      detail: { element: element}
    }));

    if (cancelCallback) {
      cancelCallback();
    }
  };

  okButton.addEventListener('click', confirmAction, {once: true});
  cancelButton.addEventListener('click', cancelAction, {once: true});

  if (confirmationCheck) {
    confirmationCheck.addEventListener('change', checkAction);
  }

  cancelButton.focus();

  if (deleteButton) {
    deleteButton.addEventListener('click', confirmAction, {once: true});
  }

  document.dispatchEvent(new CustomEvent('promote:shortcuts--register', {
    detail: {
      key: 'Escape',
      group: 'confirm-dialog',
      handler: cancelAction,
      options: { prepend: true }
    }
  }));

  return false;
}
